import * as React from "react";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { CzechResourcesDictionary } from "Translations/CzechResourcesDictionary";
import { Routes } from "Routes/Routes";
import { Layout } from "Components/Layout/Layout";
import { Provider } from "react-redux";
import appStore from "State/Store";
import { PersistGate } from "redux-persist/integration/react";
import { FetchResponse, setupClient } from "Api/Api";
import { BrowserRouter } from "react-router-dom";
import { ModuleLoadingFallback } from "Components/Layout/ModuleLoadingFallback";
import { JWT_KEY } from "Utils/AuthUtils";
import { trackUserIdentification } from "Utils/TrackingUtils";
import { useYupLocale } from "Hooks/useYupLocale";
import {
  extendSignOutDate,
  resetSession,
} from "State/Auth/Session/SessionSlice";
import { CurrencyCode } from "Models/CurrencyCodes";

export const APP_CURRENCY_CODE = CurrencyCode.CZK;

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources: {
      en: CzechResourcesDictionary,
    },
    lng: "en",
    fallbackLng: "en",

    interpolation: {
      escapeValue: false,
    },
  });

const responseMiddleware = {
  name: "auth-middleware",
  fn: (response: FetchResponse<unknown, any>) => {
    if (response.status === 401) {
      appStore.store.dispatch(resetSession({}));
    } else {
      appStore.store.dispatch(extendSignOutDate());
      trackUserIdentification();
    }
    return response;
  },
};

function App() {
  useYupLocale();

  setupClient({
    apiUrl: import.meta.env.VITE_API_URL,
    jwtKey: JWT_KEY,
    responseMiddlewares: [responseMiddleware],
  });

  return (
    <Provider store={appStore.store}>
      <PersistGate loading={null} persistor={appStore.persistor}>
        <BrowserRouter>
          <Layout>
            <React.Suspense fallback={<ModuleLoadingFallback />}>
              <Routes />
            </React.Suspense>
          </Layout>
        </BrowserRouter>
      </PersistGate>
    </Provider>
  );
}

export default App;
